<!-- src/components/Sites/ListTooltip.vue -->
<template>
  <div v-if="params.value && params.value.length > 0" class="bg-gray-800 text-white text-sm rounded shadow-lg p-2 z-50">
    <ul class="space-y-1">
      <li v-for="(role, index) in params.value" :key="index">
        <span
            :style="{ backgroundColor: `#${role.color}` }"
            class="w-3 h-3 rounded-full inline-block mr-2"
        ></span>
        <span>{{ role.role_title }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'RolesTooltip',
  props: ['params']
};
</script>
